const joinByName = list =>
  list.reduce((acc, current) => [...acc, current.name], []).join(", ");

export default joinByName;
